import React, { useEffect } from "react";
import "./Progressbar.css";
import { motion, useAnimation } from "framer-motion";
import { useInView } from "react-intersection-observer";

const Progressbar = ({ targetPercentage }) => {
  const [ref, inView] = useInView({
    triggerOnce: true,
  });

  const controls = useAnimation();

  useEffect(() => {
    if (inView) {
      controls.start({ width: `${targetPercentage}%` });
    }
  }, [inView, controls, targetPercentage]);

  return (
    <motion.div
      ref={ref}
      className="progress-bar"
      initial={{ width: "0%" }}
      animate={controls}
      transition={{ duration: 2 }}
    ></motion.div>
  );
};

const targetPercentages = [80, 80, 70, 80, 80, 90, 50, 50];
const elementTexts = [
  "AI - Prompt Engineering",
  "React - Next.js",
  "React Native",
  "TypeScript",
  "Redux - Zustand - TanStack Query",
  "MUI - Tailwind - Shadcn",
  "SQL - MongoDB",
  "C# - .NET - Node.js",
];

const ProgressbarList = () => {
  return (
    <div className="bars-wrapper">
      <div className="bars-wrapper-child">
        {targetPercentages.slice(0, 4).map((target, index) => (
          <div className="bar-wrapper" key={index}>
            <div className="bar-title">
              <h4 className="bar-skill-title">{elementTexts[index]}</h4>
              <h4 className="bar-percentage">{target}%</h4>
            </div>
            <div className="bar">
              <Progressbar targetPercentage={target} />
            </div>
          </div>
        ))}
      </div>
      <div className="bars-wrapper-child">
        {targetPercentages.slice(4, 8).map((target, index) => (
          <div className="bar-wrapper" key={index}>
            <div className="bar-title">
              <h4 className="bar-skill-title">{elementTexts[index + 4]}</h4>
              <h4 className="bar-percentage">{target}%</h4>
            </div>
            <div className="bar">
              <Progressbar targetPercentage={target} />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ProgressbarList;
